<template>
  <uiCard
    class="ticket"
    :class="{ assigned: ticket.assigned }"
    @click="onTicketClick"
  >
    <div class="header" @click="toggleControls">
      <img
        class="icon"
        :src="require(`@/assets/emoji/${ticket.icon}.png`)"
        v-if="ticket.icon"
      />
      <div class="right">
        <div class="name" v-if="ticket.client">
          {{ ticketClientFullname }}
        </div>
        <div class="name" v-else>Неизвестно</div>
        <div class="info" :class="{ assigned, closed }">
          {{ status }}
          <span v-if="closed"> &rarr; в {{ closedAt }} </span>
          <span v-else-if="assigned && ticket.assignedTo">
            &rarr; {{ ticket.assignedTo.name }}
            {{ ticket.assignedTo.surname }}
          </span>
          <span v-else>&rarr; ждёт {{ waitTime }}</span>
        </div>
      </div>
    </div>

    <div class="controls" v-if="controls">
      <div class="button" @click="openChat">Открыть чат</div>
      <div class="button green" @click="takeTicket" v-if="canTake">Взять</div>
      <div
        class="button green"
        @click="changeLine('first')"
        v-if="canChangeLapka"
      >
        В Лапку
      </div>
      <div class="button green" @click="mergeTicket" v-if="canMerge">
        Объединить
      </div>
      <div class="button green" @click="closeTicket" v-if="canClose">
        Закрыть
      </div>

      <div class="blocker" v-if="loading">
        <uiLoader />
      </div>
    </div>
    <div class="text" @click="openControls" v-else>
      {{ ticket.start?.text }}
    </div>
  </uiCard>
</template>

<script>
import {
  format,
  formatDistanceToNowStrict,
  differenceInMinutes
} from 'date-fns'
import { ru as ruLocale } from 'date-fns/locale'
import { API } from '@/config'

export default {
  name: 'Ticket',
  props: {
    ticket: Object
  },
  data () {
    return {
      loading: false,
      controls: false,
      lines: {
        first: 'Лапку',
        dogology: 'Догологию',
        bk: 'Белый Клык'
      }
    }
  },
  computed: {
    line () {
      return this.ticket.line
    },
    assigned () {
      return this.ticket.assigned
    },
    closed () {
      return this.ticket.closed
    },
    closedAt () {
      return format(new Date(this.ticket.closedAt), 'HH:mm')
    },
    canTake () {
      return !this.assigned
    },
    canChangeLapka () {
      return !this.isBK && this.line !== 'first'
    },
    canChangeDogology () {
      return !this.isBK && this.line !== 'dogology'
    },
    canChangeBk () {
      return !this.isBK && this.line !== 'bk'
    },
    canMerge () {
      return !this.isBK
    },
    canClose () {
      return !this.closed
    },
    waitTime () {
      let t = this.ticket
      let diff = differenceInMinutes(this.$now(), new Date(t.createdAt))
      let unit = 'minute'
      if (diff < 0) unit = 'second'
      return formatDistanceToNowStrict(new Date(t.createdAt), {
        unit: unit,
        locale: ruLocale,
        addSuffix: true
      }).replace(' назад', '')
    },
    status () {
      if (this.closed) return 'Закрыт'
      if (this.assigned) return 'В работе'
      return 'Новый'
    },
    isBK () {
      return this.$hasRole('bk')
    },
		ticketClientFullname() {
      if (!this.ticket.client) return ''

      return [
				this.ticket.client.roles?.includes('love') && '❤️',
				this.ticket.client.name,
				this.ticket.client.surname,
				this.ticket.client.midname
			]
        .filter(Boolean)
        .join(' ')
		}
  },
  methods: {
    onTicketClick () {
      if (this.closed) this.openChat()
    },
    openControls () {
      if (!this.closed) this.controls = true
    },
    toggleControls () {
      if (!this.closed) this.controls = !this.controls
    },
    openChat () {
      this.$router.push('/chats/' + this.ticket.chat)
    },
    async takeTicket () {
      let confirm = await this.$confirm('Берёшь этот тикет?')
      if (!confirm) return

      if (this.loading) return
      this.loading = true

      let { data } = await this.$http.post(API.TICKETS.take, {
        id: this.ticket.id
      })
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }

      this.completeAction(data)
      this.loading = false
      this.openChat()
    },
    async changeLine (line) {
      let confirm = await this.$confirm(
        'Отправить тикет в ' + this.lines[line] + '?'
      )
      if (!confirm) return

      if (this.loading) return
      this.loading = true

      let payload = { id: this.ticket.id, line: line }
      let { data } = await this.$http.post(API.TICKETS.changeLine, payload)
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }
      this.completeAction(data)
      this.loading = false
    },
    async mergeTicket () {
      return
      let confirm = await this.$confirm('Это точно продолжение старого тикета?')
      if (!confirm) return

      if (this.loading) return
      this.loading = true

      let payload = { id: this.ticket.id }
      let { data } = await this.$http.post(API.TICKETS.merge, payload)
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }
      this.$emit('update', data.chat)
      this.$store.commit('removeFromArray', {
        path: 'tickets',
        data: this.ticket.id
      })
    },
    async closeTicket () {
      let confirm = await this.$confirm('Точно закрываем?')
      if (!confirm) return

      let payload = { ticket: this.ticket.id }
      let { data } = await this.$http.post(API.TICKETS.close, payload)
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }
      this.$emit('update', data.chat)
      this.completeAction(data)
      this.loading = false
    },
    completeAction (data) {
      this.$store.commit('updateInArray', {
        path: 'chats',
        data: data.chat
      })
      this.$store.commit('updateInArray', {
        path: 'tickets',
        data: data.ticket
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.ticket {
  margin-bottom: 20px;
  cursor: pointer;

  .header {
    display: flex;
    align-items: center;
  }

  .icon {
    height: 40px;
  }

  .right {
    margin-left: 10px;
  }

  .name {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 2px;
  }

  .info {
    color: @red;
    font-size: 12px;
    font-weight: bold;

    &.assigned {
      color: @accent;
    }

    &.closed {
      color: @green-alt;
    }

    span {
      opacity: 0.5;
      color: #000;
      font-weight: normal;
    }
  }

  .text {
    padding: 10px 0;
    font-size: 15px;
    opacity: 0.5;
  }
}

.controls {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .blocker {
    width: 100%;
    height: 100%;
    background: #fff;
    position: absolute;
    opacity: 0.9;
    cursor: default;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button {
    width: fit-content;
    font-size: 13px;
    font-weight: 400;
    padding: 6px 10px;
    background: @grey;
    border-radius: 20px;
    margin-top: 8px;
    margin-right: 6px;
    cursor: pointer;

    &:active {
      transform: scale(0.96);
    }
  }
}
</style>
